import { useMemo } from 'react';

export default function useDefaultId(forcedId?: string) {
    return useMemo(() => forcedId || `$${Math.floor(Math.random() * 16777215).toString(16)}`, [forcedId]);
}
